// src/admin/components/StatusUpdateModal.js
import React, { useState } from 'react';
import './StatusUpdateModal.css';
import { USER_STATUS, getStatusInfo } from '../utils/helpers';

const StatusUpdateModal = ({ user, onSubmit, onClose }) => {
  const [selectedStatus, setSelectedStatus] = useState(user.is_active);
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    {
      value: USER_STATUS.ACTIVE,
      ...getStatusInfo(USER_STATUS.ACTIVE),
      description: 'User can access all features',
      disabled: false
    },
    {
      value: USER_STATUS.SUSPENDED,
      ...getStatusInfo(USER_STATUS.SUSPENDED),
      description: 'User access is temporarily blocked',
      disabled: false
    },
    {
      value: USER_STATUS.EXPIRED,
      ...getStatusInfo(USER_STATUS.EXPIRED),
      description: 'Automatically set when plan ends — cannot be set manually',
      disabled: true
    }
  ];

  const handleSubmit = async () => {
    if (selectedStatus === user.is_active) {
      onClose();
      return;
    }

    try {
      setLoading(true);
      await onSubmit(selectedStatus);
    } catch (err) {
      console.error('Failed to update status:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container modal-sm p-4" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <i className="bi bi-shield-check"></i>
            Update User Status
          </h2>
          <button className="close-btn" onClick={onClose}>
            <i className="bi bi-x"></i>
          </button>
        </div>

        <div className="status-modal-content">
          <div className="user-info-banner">
            <div className="user-avatar-large">
              {user.name.charAt(0).toUpperCase()}
            </div>
            <div>
              <h3>{user.name}</h3>
              <p>{user.email}</p>
            </div>
          </div>

          <div className="status-options">
            {statusOptions.map((option) => (
              <label
                key={option.value}
                className={`status-option ${selectedStatus === option.value ? 'selected' : ''} ${option.disabled ? 'status-option-disabled' : ''}`}
                style={option.disabled ? { opacity: 0.45, cursor: 'not-allowed' } : {}}
              >
                <input
                  type="radio"
                  name="status"
                  value={option.value}
                  checked={selectedStatus === option.value}
                  onChange={(e) => !option.disabled && setSelectedStatus(parseInt(e.target.value))}
                  disabled={option.disabled}
                />
                <div className="status-option-content">
                  <div className="status-option-header">
                    <i className={`bi ${option.icon}`} style={{ color: option.color }}></i>
                    <span className="status-label">{option.label}</span>
                    {option.disabled && <span style={{ fontSize: '0.75rem', color: '#9ca3af', marginLeft: 'auto' }}>Auto only</span>}
                    {!option.disabled && selectedStatus === option.value && (
                      <i className="bi bi-check-circle-fill check-icon"></i>
                    )}
                  </div>
                  <p className="status-description">{option.description}</p>
                </div>
              </label>
            ))}
          </div>

          {selectedStatus !== user.is_active && (
            <div className="status-change-warning">
              <i className="bi bi-info-circle"></i>
              <span>
                You are changing status from <strong>{getStatusInfo(user.is_active).label}</strong> to <strong>{getStatusInfo(selectedStatus).label}</strong>
              </span>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={handleSubmit}
            disabled={loading || selectedStatus === user.is_active}
          >
            {loading ? (
              <>
                <span className="spinner-small"></span>
                Updating...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle"></i>
                Update Status
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusUpdateModal;